/** 平台標籤映射 — 全站統一使用 */
export const PLATFORM_LABELS: Record<string, string> = {
  android: 'Android',
  ios: 'iOS',
  tv_android: 'Android TV',
  tv_ios: 'Apple TV',
  macos: 'macOS',
  windows: 'Windows',
};

/** 平台 Tag 顏色 */
export const PLATFORM_COLORS: Record<string, string> = {
  android: 'green',
  ios: 'blue',
  windows: 'cyan',
  macos: 'purple',
  tv_android: 'lime',
  tv_ios: 'geekblue',
};

/** 頻道標籤和顏色 */
export const CHANNEL_COLORS: Record<string, string> = {
  production: 'green',
  staging: 'orange',
  preview: 'blue',
};

/** HTTP Method 顏色 */
export const METHOD_COLORS: Record<string, string> = {
  GET: 'green',
  POST: 'blue',
  PUT: 'orange',
  DELETE: 'red',
  PATCH: 'purple',
};

/** 暗色模式 localStorage key */
export const THEME_KEY = 'theme-mode';
